import { Box, Stack } from '@mui/material';

import { CalculateTourCo2 } from '@/domain/impact-calculate-tour/entities/calculate-tour-co2.entity';
import { CalculateTourEnv } from '@/domain/impact-calculate-tour/entities/calculate-tour-env.entity';
import { CalculateTourEss } from '@/domain/impact-calculate-tour/entities/calculate-tour-ess.entity';
import {
  selectImpactCalculateTourCo2ForProject,
  selectImpactCalculateTourEnvForProject,
  selectImpactCalculateTourEssForProject,
} from '@/domain/impact-calculate-tour/impact-calculate-tour.selectors';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { useAppSelector } from '@/ui/hook/store';
import { ShowDetailsMode } from '@/ui/pages/app/components/project-page/ProjectScores';
import {
  ProjectScoresDetailsData,
  ProjectScoresDetailsItemParams,
} from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';
import { ProjectScoresDetailsCard } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetailsCard';
import { ProjectScoresDetailsTitle } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetailsTitle';

import { prepareProjectTourScoreDetailsDataCo2 } from '../utils/prepare-project-score-details-data/co2';
import { prepareProjectTourScoreDetailsDataEnv } from '../utils/prepare-project-score-details-data/env';
import { prepareProjectTourScoreDetailsDataEss } from '../utils/prepare-project-score-details-data/ess';

export function ProjectTourScoresDetails({
  project,
  showDetailsMode,
  onClickDetailsItem,
}: {
  project: ProjectTour;
  showDetailsMode: ShowDetailsMode;
  onClickDetailsItem: (params: ProjectScoresDetailsItemParams) => void;
}) {
  const calculateCo2 = useAppSelector(
    selectImpactCalculateTourCo2ForProject(project.id),
  );
  const calculateEnv = useAppSelector(
    selectImpactCalculateTourEnvForProject(project.id),
  );
  const calculateEss = useAppSelector(
    selectImpactCalculateTourEssForProject(project.id),
  );
  const data: ProjectScoresDetailsData[] = prepareData(
    showDetailsMode,
    calculateCo2,
    calculateEnv,
    calculateEss,
  );

  if (data === null) {
    return <></>;
  }
  return (
    <Stack spacing={2}>
      {data.map((x) => (
        <Box key={x.title}>
          <ProjectScoresDetailsTitle title={x.title} />
          <ProjectScoresDetailsCard
            data={x}
            onClickDetailsItem={onClickDetailsItem}
          />
        </Box>
      ))}
    </Stack>
  );
}

function prepareData(
  showDetailsMode: ShowDetailsMode,
  calculateCo2: CalculateTourCo2,
  calculateEnv: CalculateTourEnv,
  calculateEss: CalculateTourEss,
): ProjectScoresDetailsData[] {
  switch (showDetailsMode) {
    case 'none':
      return [];
    case 'co2':
      return prepareProjectTourScoreDetailsDataCo2(calculateCo2);
    case 'env':
      return prepareProjectTourScoreDetailsDataEnv(calculateEnv);
    case 'ess':
      return prepareProjectTourScoreDetailsDataEss(calculateEss);
  }
}
